export const APP_ROUTES = {
  HOME: `/${APP_PATH}`,
  OPTIONS: `/${APP_PATH}/options`,
  EXAMPLE: `/${APP_PATH}/example`,
  PRICE_LADDER: `/${APP_PATH}/priceladder`
};

export const OPTIONS_ROUTES = {
  DEFAULT: '',
  TAGS: 'tags',
  CHART: 'chart',
  MODAL: 'modal',
  INPUTS: 'inputs',
  HEADER: 'header',
  BUTTONS: 'buttons',
  SERVICES: 'services',
  TOOLTIPS: 'tooltips',
  NAVIGATION: 'navigation',
  DATE_PICKER: 'date-picker',
  TRANSLATIONS: 'translations',
  SELECT_PICKER: 'select-picker'
};

export const NAVIGATION_ROUTE = {
  TRADE: 'trade',
  MARKETS: 'markets',
  ASSETS: 'assets',
  DEALER: 'dealer',
  SIGNAL: 'signal',
  CALENDAR: 'calendar',
  NEWS: 'news',
  MODAL: 'modal'
};

export const AUTHENTICATION_ROUTES = {
  LOGIN: `/${APP_PATH}/login`,
  SIGN_UP_CRM: `/${APP_PATH}/sign-up-crm`,
  SIGN_UP_DEMO: `/${APP_PATH}/sign-up-demo`,
  FORGOT_PASSWORD_CRM: `/${APP_PATH}/forgot-password-crm`,
  FORGOT_PASSWORD_LIVE: `/${APP_PATH}/forgot-password-live`,
  RESET_PASSWORD: `/${APP_PATH}/reset-password`
};

export const SECURED_ROUTES = {
  TRADE: `/${APP_PATH}/trade`,
  MARKETS: `/${APP_PATH}/markets`,
  ASSETS: `/${APP_PATH}/assets`,
  SIGNAL: `/${APP_PATH}/signal`,
  DEALER: `/${APP_PATH}/dealer`,
  NEWS: `/${APP_PATH}/news`,
  CALENDAR: `/${APP_PATH}/calendar`,
  EDUCATION: `/${APP_PATH}/education`,
  QUOTE: `/${APP_PATH}/quote`,
  LOGOUT: 'logout'
};
